import axios from "axios";

const ORION_API_BASE =
  process.env.REACT_APP_ORION_API_BASE || "http://3.95.95.62:8027";

const orionHttp = axios.create({
  baseURL: ORION_API_BASE,
  timeout: 15000,
  headers: {
    Accept: "application/json",
  },
});

export function isOrionUsername(username) {
  return typeof username === "string" && username.trim().toLowerCase().endsWith("@orion.com");
}

export async function loginOrionUser({ username, password }) {
  const body = new URLSearchParams();
  body.append("grant_type", "password");
  body.append("username", username.trim());
  body.append("password", password);
  body.append("scope", "");
  body.append("client_id", "");
  body.append("client_secret", "");

  const { data } = await orionHttp.post("/api/v1/auth/token", body, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return data;
}

export async function fetchOrionProfile(accessToken) {
  const { data } = await orionHttp.get("/api/v1/auth/me", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return data;
}

export function normalizeOrionUser(profile, username) {
  return {
    name:
      profile?.full_name ||
      profile?.name ||
      profile?.email ||
      username,
    email: profile?.email || username,
    role: profile?.role || profile?.user_role || "orion-user",
    provider: "orion",
  };
}
